<template>
  <div class="drawer-wrapper">
    <el-drawer :wrapperClosable="true" :title="title" :visible.sync="dialogVisible" size="50%"
               :before-close="handleClose" direction="rtl">

      <div class="demo-drawer__content">
        <el-form :model="addFrom" :rules="rules" ref="ruleForm">
          <el-row :gutter="35">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="平台名称" prop="name" :label-width="formLabelWidth">
                <el-input v-model="addFrom.name" placeholder="请输入平台名称" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="平台UID" prop="name" :label-width="formLabelWidth">
                <el-input v-model="addFrom.uid" placeholder="请输入平台UID" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="AK秘钥" prop="ak" :label-width="formLabelWidth">
                <el-input v-model="addFrom.ak" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入AK秘钥" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="SK秘钥" prop="sk" :label-width="formLabelWidth">
                <el-input v-model="addFrom.sk" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入SK秘钥" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="平台性质" prop="is_test" :label-width="formLabelWidth" style="width: 90%;">
                <el-radio-group v-model="addFrom.is_test">
                  <el-radio :label="0">正式平台</el-radio>
                  <el-radio :label="1">测试平台</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="使用状态" prop="is_use" :label-width="formLabelWidth" style="width: 90%;">
                <el-radio-group v-model="addFrom.is_use">
                  <el-radio :label="1">使用中</el-radio>
                  <el-radio :label="0">未使用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

          </el-row>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="AddNone">取 消</el-button>
        <el-button type="primary" @click="addPush">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {KsNovalManagement} from "@/api/ksNovalManagement";
import {processErrors} from "@/utils/errorHandler";
const api = KsNovalManagement();
export default {
  props: ['dialogVisible', "editID"],
  components: {},
  data() {
    return {
      title: "新增",
      formLabelWidth: "140px",
      addFrom: {
        name: "",
        uid:'',
        ak: "",
        sk: "",
        is_use: 1,
        is_test: 1,
      }, 
      rules: {
        name: [
          {required: true, message: '请输入平台名称', trigger: 'blur'},
        ],
        uid: [
          {required: true, message: '请输入平台UID', trigger: 'blur'},
        ],
        ak: [
          {required: true, message: '请输入AK秘钥', trigger: 'blur'},
        ],
        sk: [
          {required: true, message: '请输入SK秘钥', trigger: 'blur'},
        ],
      },
    };
  },
  mounted() {
    if (this.editID != "") {
      api.ApiPlatformInfo({id: this.editID}).then(res => {
        if (res.code == 0) {
          this.title = "编辑"
          this.addFrom = res.data
        } else {
          processErrors(res);
        }
      })
    }
  },
  methods: {
    handleClose(done) {
      this.$emit('NoneDlog');
      this.$refs['ruleForm'].resetFields();
    },

    AddNone() {
      this.addFrom = {
        name: "",
        uid:'',
        ak: "",
        sk: "",
        is_use: 1,
        is_test: 1,
      }
      this.title = ""
      this.$refs['ruleForm'].resetFields();
      this.$emit('NoneDlog');
    },

    addPush() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let createText = ''
          if (this.editID == "") {
            createText = "创建成功";
          } else {
            this.addFrom.id = this.editID
            createText = "修改成功";
          }

          api.ApiPlatformEdit(this.addFrom).then(res => {
            if (res.code == 0) {
              this.$message({
                message: createText,
                type: 'success'
              });
              this.$emit('AddOk');
            } else {
              processErrors(res);
            }
          })
        } else {
          return false;
        }
      });
    }
  },
}
</script>
<style lang='scss' scoped>
.demo-drawer__content {
  height: calc(100% - 80px); /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto; /* 添加垂直滚动条 */
  margin-top: 20px;
  overflow-x: hidden;
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  margin: 0 10px;
  width: calc(50% - 20px);
}
</style>